import { useParams } from 'react-router-dom'

export const useIdParam = () => {
  const { id } = useParams()
  const isAsNumber = Number(id)

  return { id: isAsNumber || 0 }
}
